/* eslint-disable react/require-optimization */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { reduxForm } from "redux-form";
import MonthInput from "./MonthInput";
import DayInput from "./DayInput";
import YearInput from "./YearInput";
import RadioInput from "./RadioInput";
import TextInput from "./TextInput";
import StateInput from "./StateInput";
import WizardFooter from "./WizardFooter";

export const fields = [
  "street",
  "birthMonth",
  "birthDay",
  "birthYear",
  "city",
  "state",
  "zip",
  "county",
  "worked_for_us_before",
];

const validate = (values, props) => {
  const errors = {};
  ["street", "city", "county", "state", "zip", "worked_for_us_before"].forEach(
    field => {
      if (!values[field]) {
        errors[field] = props.allText.shared.required;
      }
    }
  );

  const stateRegex = /^[A-Z]{2}$/i;
  const zipCodeRegex = /^\d{5}([- ]\d{4})?$/i;

  if (!values.state) {
    errors.state = props.allText.shared.required;
  } else if (!stateRegex.test(values.state)) {
    errors.state = props.allText.shared.invalid_state;
  }
  if (!values.zip) {
    errors.zip = props.allText.shared.required;
  } else if (!zipCodeRegex.test(values.zip)) {
    errors.zip = props.allText.shared.invalid_zip_;
  }

  if (!values.birthMonth) {
    errors.birthMonth = props.allText.shared.required;
  }

  if (!values.birthDay) {
    errors.birthDay = props.allText.shared.required;
  }

  if (!values.birthYear) {
    errors.birthYear = props.allText.shared.required;
  }
  return errors;
};

export class WizardFormEmployeeInfo02 extends Component {
  render() {
    const {
      allText,
      fields: {
        street,
        birthMonth,
        birthDay,
        birthYear,
        city,
        county,
        state,
        zip,
        worked_for_us_before,
      },
      handleSubmit,
      previousPage,
    } = this.props;

    const text = { ...allText.shared, ...allText.info01, ...allText.info02 };
    const progress = 0;

    return (
      <form onSubmit={handleSubmit} className="form-horizontal">
        <div className="wizard-page-content employee-info">
          <div className="page-title-container">
            <span className="page-title">{text.title}</span>
          </div>

          <div className="row">
            <div className="col-12 col-sm-12 col-md-5 bigger">
              <div className="wizard-text">{text.street}</div>
              <TextInput text={text} field={street} placeholder={text.street} />
            </div>

            <div className="col-12 col-sm-4 col-md-3 shorter">
              <div className="wizard-text hidden-xs">{text.city}</div>
              <TextInput text={text} field={city} placeholder={text.city} />
            </div>

            <div className="col-6 col-sm-4 col-md-3 shorter">
              <div className="wizard-text">{text.state}</div>
              <StateInput text={text} field={state} />
            </div>

            <div className="clearfix visible-md-block" />

            <div className="col-6 col-sm-4 col-md-2 shorter">
              <div className="wizard-text">{text.zip}</div>
              <TextInput text={text} field={zip} placeholder={text.zip} />
            </div>

            <div className="col-12 col-sm-4 col-md-6 shorter">
              <div className="wizard-text">{text.county}</div>
              <TextInput text={text} field={county} placeholder={text.county} />
            </div>

            <div className="col-12 col-sm-6 col-md-4 dob-container">
              <span>
                <div className="wizard-text">{text.birthDate}</div>
                <div className="row">
                  <div className="col-4">
                    <MonthInput text={text} field={birthMonth} />
                  </div>
                  <div className="col-3 cell-tight">
                    <YearInput
                      text={text}
                      field={birthYear}
                      monthSelected={birthMonth}
                      shouldCheckMonth={true}
                    />
                  </div>
                  <div className="col-5">
                    <DayInput
                      text={text}
                      field={birthDay}
                      monthSelected={birthMonth}
                      yearSelected={birthYear}
                    />
                  </div>
                </div>
              </span>
              <span className="wizard-text">{text.date_selection}</span>
            </div>

            <div className="col-6 col-sm-8 col-md-4 last-item-margin">
              <div className="wizard-text">{text.workedForUsBefore}</div>
              <RadioInput text={text} field={worked_for_us_before} />
            </div>
          </div>
        </div>
        <WizardFooter
          text={text}
          previousPage={previousPage}
          progress={progress}
        />
      </form>
    );
  }
}

WizardFormEmployeeInfo02.propTypes = {
  allText: PropTypes.object.isRequired,
  fields: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  previousPage: PropTypes.func.isRequired,
};

export default reduxForm({
  form: "wizard",
  fields,
  destroyOnUnmount: false,
  validate,
})(WizardFormEmployeeInfo02);



// WEBPACK FOOTER //
// ./src/components/WizardFormEmployeeInfo02.js